import { useState } from "react";
import { Plus, X } from "lucide-react";

export function MemoryEditor({ memories, onAdd, onDelete }) {
  const [val, setVal] = useState("");
  return (
    <div>
      <ul className="space-y-1.5 mb-2">
        {memories.length === 0 && (
          <li className="text-xs text-neutral-500 italic">
            Pin facts the character should always remember (e.g. "My name is Aria and I have a scar over my left eye.")
          </li>
        )}
        {memories.map((m, i) => (
          <li key={i} data-testid={`memory-item-${i}`} className="flex items-start gap-2 rounded-lg bg-white/[0.03] p-2 text-xs text-neutral-200">
            <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-yellow-400" />
            <span className="flex-1">{m}</span>
            <button
              onClick={() => onDelete(i)}
              data-testid={`memory-delete-${i}`}
              className="text-neutral-500 hover:text-white"
            >
              <X size={14} />
            </button>
          </li>
        ))}
      </ul>
      <div className="flex gap-1.5">
        <input
          data-testid="memory-input"
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), (onAdd(val), setVal("")))}
          placeholder="Add a memory…"
          className="flex-1 rounded-lg border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-white focus:border-violet-500/50 outline-none"
        />
        <button
          data-testid="memory-add-btn"
          onClick={() => { onAdd(val); setVal(""); }}
          className="flex h-8 w-8 items-center justify-center rounded-lg bg-violet-500/20 text-violet-200 hover:bg-violet-500/30"
        >
          <Plus size={14} />
        </button>
      </div>
    </div>
  );
}
